import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';

import Swal from 'sweetalert2';

import {
  HeaderService,
  ServiceOrderManagementService
} from '../../../shared';

@Component({
  selector: 'app-service-order-management-view',
  templateUrl: './service-order-management-view.component.html',
  styleUrls: ['./service-order-management-view.component.scss']
})
export class ServiceOrderManagementViewComponent implements OnInit {
  title = "ORDEM DE SERVIÇO";
  subtitle = "";
  urlBack = "/panel/service-order-management/list";

  id;

  serviceOrderManagement;

  total = 0;

  constructor(
    private headerService: HeaderService,
    private serviceOrderManagementService: ServiceOrderManagementService,
    private activatedRoute: ActivatedRoute,
    private loadingBarService: LoadingBarService,
  ) {
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle('Visualizar ordem de serviço');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);

    this.loadingBarService.start();

    this.serviceOrderManagementService.getServicesOrdersManagement(this.id).subscribe((response) => {
      this.serviceOrderManagement = response['data'];

      for (let i = 0; i < this.serviceOrderManagement.items.length; i++) {
        this.total += this.serviceOrderManagement.items[i].vlItem;
      }

      this.loadingBarService.complete();
    });
  }

  approved() {
    Swal({
      title: "Tem certeza que deseja aprovar este registro?",
      confirmButtonText: "Sim, obrigado!",
      confirmButtonClass: "sweet-button",
      showCancelButton: true,
      cancelButtonText: "Não, me equivoquei!",
      cancelButtonClass: "sweet-button-cancel",
      buttonsStyling: false
    }).then((result) => {
      if(result.value) {
        let raw = {
          idFsRequisicao: `${this.id}`
        };

        this.serviceOrderManagementService.approvedServicesOrdersManagement(raw).subscribe((response) => {
          Swal({
            type: "success",
            title: "Registro aprovado!",
            confirmButtonText: "Obrigado!",
            confirmButtonClass: "sweet-button",
            buttonsStyling: false
          });
        });
      }
    });
  }

  disapproved() {
    Swal({
      title: "Tem certeza que deseja reprovar este registro?",
      text: "Escreva o motivo abaixo.",
      confirmButtonText: "Sim, obrigado!",
      confirmButtonClass: "sweet-button",
      showCancelButton: true,
      cancelButtonText: "Não, me equivoquei!",
      cancelButtonClass: "sweet-button-cancel",
      buttonsStyling: false,
      input: 'text',
      preConfirm: (obs) => {
        return obs;
      }
    }).then((result) => {
      if(result.value) {
        let raw = {
          idFsRequisicao: `${this.id}`,
          dsObservacao: result.value
        };

        this.serviceOrderManagementService.disapprovedServicesOrdersManagement(raw).subscribe((response) => {
          Swal({
            type: "success",
            title: "Registro reprovado!",
            confirmButtonText: "Obrigado!",
            confirmButtonClass: "sweet-button",
            buttonsStyling: false
          });
        });
      }
    });
  }

}
